import HeroBg from "public/networkAutomation/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Revolutionize your network management today",
    link: "contact-us",
  },
  title: "Cloud Security , Automate & Optimize Your IT Network",
  desc: "Streamline your IT operations with cloud-native security, intelligent automation, and optimized network performance.",
  image: HeroBg,
  cmlPowered: true,
};
